
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderbookItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderbookItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_base"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price_rounded"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":89}};
    doc.loc.source = {"body":"fragment OrderbookItem on OrderbookItem {\n  amount_base\n  amount_quote\n  price_rounded\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
